/* @flow */
import "./Bootstrap.scss";
import "./App.styl";

import "react-datepicker/dist/react-datepicker.css";

import Helmet from "react-helmet";
import React from "react";
import favicon from "../../common/app/favicon";
import start from "../../common/app/start";
import { Miss } from "react-router";
import { connect } from "react-redux";
import { iframeResizerContentWindow } from "iframe-resizer/js";

import { confirmTransition, rejectTransition } from "../../common/app/actions";

import { setIsOpen } from "../../common/newsletter/actions";
import { register } from "../../common/notification/actions";

// Pages
import Home from "../home/HomePage";
import Blog from "../blog/Page";
import Offer from "../offer/Page";
import AgencyOffers from "../offers/AgencyOffers";
import BareOffer from "../offers/BareOffer";
import Contact from "../contact/Page";
import LegalNotice from "../legal/Page";
import Add from "../add/Page";
import Admin from "../admin/Page";
import Lockstep from "../lockstep/Page";
import NotFound from "../notfound/NotFoundPage";

import AppLoader from "../components/AppLoader/AppLoader";
import Match from "../components/Match";
import HeaderResponsive from "../components/HeaderResponsive/HeaderResponsive";
import NotificationRequest from "../components/NotificationRequest/NotificationRequest";
import CookiesMessage from "../components/CookiesMessage/CookiesMessage";

import { NewsletterModal } from "../components/NewsletterModal/NewsletterModal";

import ConfirmModal from "../components/ConfirmModal/ConfirmModal";
import * as firebase from "firebase/app";
import "firebase/messaging";

// v4-alpha.getbootstrap.com/getting-started/introduction/#starter-template
const bootstrap4Metas: any = [
  { charset: "utf-8" },
  {
    name: "viewport",
    content: "width=device-width, initial-scale=1, shrink-to-fit=no",
  },
  {
    "http-equiv": "x-ua-compatible",
    content: "ie=edge",
  },
];

class App extends React.Component {
  constructor() {
    super();
  }

  componentDidMount() {
    const { setIsOpen, register } = this.props;

    setTimeout(setIsOpen.bind(this, true), 20000);

    if (localStorage) {
      const messaging = firebase.messaging();

      messaging.onTokenRefresh(function () {
        localStorage.setItem("push-notification-registered", false);
        messaging
          .getToken()
          .then(async function (refreshedToken) {
            console.log("Token refreshed: ", refreshedToken);
            const rs = await register({ token: refreshedToken });
            if (rs && rs.status === 200) {
              localStorage.setItem("push-notification-registered", true);
            }
          })
          .catch(function (err) {
            console.log("Unable to retrieve refreshed token ", err);
          });
      });
    }
  }

  render() {
    const {
      currentLocale,
      transitionResolve,
      confirmTransition,
      rejectTransition,
      appPath,
    } = this.props;

    return (
      <div>
        <Helmet
          htmlAttributes={{ lang: currentLocale }}
          meta={[
            ...bootstrap4Metas,
            {
              name: "description",
              content: "Portal dla opiekunek osób starszych",
            },
            ...favicon.meta,
          ]}
          link={[...favicon.link]}
          titleTemplate="%s"
        />
        <AppLoader />

        <HeaderResponsive />
        <CookiesMessage />
        <NewsletterModal />

        <NotificationRequest />
        <ConfirmModal
          color="warning"
          title="UWAGA!"
          content="Dane nie zostały zapisane. Czy na pewno chcesz opuścić widok?"
          icon="times-circle"
          confirmButtonText="Opuść widok"
          cancelButtonText="Cofnij"
          cancelAction={rejectTransition}
          isOpen={transitionResolve !== null}
          confirmAction={confirmTransition}
        />

        <Match exactly pattern={appPath || "/"} component={Home} />
        <Match exactly pattern={`${appPath}/p/:page`} component={Home} />
        <Match exactly pattern={`${appPath}/kontakt`} component={Contact} />
        <Match
          exactly
          pattern={`${appPath}/polityka-prywatnosci`}
          component={LegalNotice}
        />
        <Match
          exactly
          pattern={`${appPath}/dodaj-ogloszenie`}
          component={Add}
        />
        <Match
          pattern={`${appPath}/offer-admin/:slug/:key`}
          component={Admin}
        />

        <Match pattern={`${appPath}/blog`} component={Blog} />
        <Match pattern={`${appPath}/oferty`} component={Offer} />

        <Match pattern={`${appPath}/offers/:slug`} component={AgencyOffers} />
        <Match pattern={`${appPath}/offer/:slug`} component={BareOffer} />

        <Miss component={NotFound} />
      </div>
    );
  }
}

App.propTypes = {
  currentLocale: React.PropTypes.string.isRequired,
};

App = connect(
  (state) => ({
    currentLocale: state.intl.currentLocale,
    transitionResolve: state.app.transitionResolve,
    appPath: state.config.appPath,
  }),
  { confirmTransition, rejectTransition, setIsOpen, register }
)(App);

export default start(App);



/** WEBPACK FOOTER **
 ** ./src/browser/app/App.js
 **/